<template>
  <div>
    <v-text-field
      v-model="search"
      prepend-inner-icon="search"
      label="Buscar projetos com captação ligada, do mesmo tipo da campanha"
      clearable
      hide-details
      @keyup.enter="fetch(1)"
    ></v-text-field>
    <div class="mt-2">
      <v-btn small flat color="primary" :loading="loading" @click="fetch(1)">Buscar</v-btn>
      <span v-if="searched" class="caption text-gray">{{ total }} encontrado(s)</span>
    </div>
    <ul v-if="items.length" class="pc-list">
      <li v-for="item in items" :key="item.projectId" class="pc-row">
        <EditorProjectThumb :project="item" small />
        <div class="pc-body">
          <div class="pc-name">{{ item.shortName || item.fullName }}</div>
          <div class="pc-meta">
            <span><i class="fal fa-building mr-1"></i>{{ item.institutionName || "Sem instituição" }}</span>
            <span class="pc-meta__id">#{{ item.projectId }}</span>
          </div>
        </div>
        <v-btn small depressed color="primary" class="pc-add" :loading="addingId === item.projectId" @click="add(item)">
          <i class="fal fa-plus mr-2"></i>Adicionar
        </v-btn>
      </li>
    </ul>
    <div v-if="searched && totalPages > 1" class="text-xs-center">
      <v-pagination v-model="page" :length="totalPages" :total-visible="7" @input="fetch"></v-pagination>
    </div>
  </div>
</template>

<script>
// Busca paginada de projetos fora da campanha (substitui carregar todas as instituições no front) + adicionar.
import CampaignEditorService from "@/scripts/services/campaignEditor.service";
import EditorProjectThumb from "./EditorProjectThumb.vue";

const service = new CampaignEditorService();
const PAGE_SIZE = 20;

export default {
  name: "ProjectCandidates",
  components: { EditorProjectThumb },
  props: {
    campaignId: { type: [Number, String], required: true },
  },
  data() {
    return { search: "", items: [], total: 0, page: 1, loading: false, searched: false, addingId: null };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / PAGE_SIZE);
    },
  },
  methods: {
    add(item) {
      this.addingId = item.projectId;
      service.addProject(this.campaignId, item.projectId)
        .then(() => {
          this.$store.commit("SET_SNACKBAR_SUCCESS_MESSAGE", "Projeto adicionado à campanha.");
          this.$emit("added", item);
          return this.fetch(this.page);
        })
        .catch(() => {})
        .finally(() => {
          this.addingId = null;
        });
    },
    fetch(page) {
      this.page = page || 1;
      this.loading = true;
      return service
        .searchProjects(this.campaignId, this.search, this.page)
        .then((result) => {
          this.items = Object.freeze(result.items || []);
          this.total = result.total || 0;
          this.searched = true;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.pc-list {
  list-style: none;
  padding: 0;
  margin: 12px 0 0;
  border: 1px solid var(--ced-border, #e3e5ec);
  border-radius: 8px;
}
.pc-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 12px;
}
.pc-row + .pc-row {
  border-top: 1px solid var(--ced-border, #e3e5ec);
}
.pc-row:hover {
  background: #fafbfc;
}
.pc-body {
  flex: 1;
  min-width: 0;
}
.pc-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--ced-text, #4c4d4f);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pc-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  margin-top: 2px;
  font-size: 13px;
  color: var(--ced-muted, #80849a);
}
.pc-meta__id {
  color: #a3a7b8;
}
.pc-add {
  flex: 0 0 auto;
  margin: 0;
  border-radius: 999px;
  text-transform: none;
  font-weight: 600;
}
</style>
